module.exports = __webpack_public_path__ + "img/ic_not-available.2c7468bd.svg";